/* globals Beacon */

import svg4everybody from 'svg4everybody';
import Tabby from 'tabbyjs/dist/js/tabby';
import GLightbox from 'glightbox';
import { Addresses } from './components/addresses';
import { parseDataAttr } from './components/utils';
import { Toasts } from './components/toasts';
import { Toggle } from './components/toggle';
import { Tooltips } from './components/tooltips';
import { Fields } from './components/fields.js';
import { Modals } from './components/modals.js';
import Splide from '@splidejs/splide';
import { BaseApp } from './base-app.js';

class App extends BaseApp {
  init() {
    this.initBeacon();
    this.initNav();
    this.initAccordions();
    this.initTabby();
    this.initLightBox();
    this.initSplide();
    this.initCopy(document);
    svg4everybody();

    this.toasts = new Toasts();
    this.toggle = new Toggle();
    this.tooltips = new Tooltips();
    this.fields = new Fields();
    this.modals = new Modals();
    this.addresses = new Addresses();
    this.addresses.initAddressLinks(document);
    console.log('App initialised');
  }

  initCopy(node) {
    node.querySelectorAll('.js-copy').forEach((el) => {
      el.addEventListener('click', (e) => {
        e.preventDefault();
        navigator.clipboard.writeText(el.dataset.copy);
        this.toasts.create({
          message: 'Copied to clipboard',
        });
      });
    });
  }

  initSplide() {
    document.querySelectorAll('.splide').forEach((el) => {
      let options = el.dataset.options ? JSON.parse(el.dataset.options) : {};
      new Splide(el, options).mount();
    });
  }

  initLightBox() {
    GLightbox();
  }

  initBeacon() {
    document.addEventListener(
      'click',
      (event) => {
        let beacon = event.target.closest('[data-beacon]');
        if (!beacon) return;
        event.preventDefault();
        let footer = parseDataAttr(beacon, 'data-beacon-footer', false);
        Beacon('prefill', {
          name: parseDataAttr(beacon, 'data-beacon-name', ''),
          email: parseDataAttr(beacon, 'data-beacon-email', ''),
          subject: parseDataAttr(beacon, 'data-beacon-subject', ''),
          text: parseDataAttr(beacon, 'data-beacon-text', '') + (footer ? '\n\n\n\n------------------------------------------\n' + footer : ''),
        });
        Beacon('navigate', parseDataAttr(beacon, 'data-beacon-navigate', '/ask/chat/'));
        Beacon('open');
      },
      false,
    );
  }

  initNav() {
    document.addEventListener(
      'change',
      (event) => {
        let select = event.target.closest('[data-select-nav]');
        if (!select) return;
        event.preventDefault();
        let option = select.options[select.selectedIndex];
        window.location = select.value + (option ? parseDataAttr(option, 'data-query-string', '') : '');
      },
      false,
    );
  }

  initTabby() {
    if (document.querySelector('[data-tabs]')) {
      new Tabby('[data-tabs]');
    }
  }
}

window.App = new App();
